import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../contexts';
import { useAggregatedState } from '../../../helpers';

export const EditProjectManagersContext = React.createContext(null);

const { Provider } = EditProjectManagersContext;
export const EditProjectManagersProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [ state, setState ] = useAggregatedState({
        roles: null,
        isLoadingTeam: false,
        currentTeam: null,
        editedAssignment: null,
        isSaved: false
    });

    const getRolesAsync = async () => {
        try {            
            const rolesApi = await fetchAuthorized(ApiRoutes.Role.GetRoles(),
            {                    
                method: HttpMethods.GET
            }); 
    
            const roles = await rolesApi.json();
            setState({ roles });
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    const getTeamAsync = async (teamId) => {
        setState({ isSaved: false, isLoadingTeam: true });

        try {            
            const teamApi = await fetchAuthorized(ApiRoutes.User.GetProjectTeam({ projectTeamId: teamId }),
            {                    
                method: HttpMethods.GET
            }); 
    
            const currentTeam = await teamApi.json();
            setState({ currentTeam, isLoadingTeam: false });
          }
    
          catch (ex){
            setState({ isLoadingTeam: false });
            console.error(ex);
            console.error(ex.details);
          }
    }

    const saveProjectTeamAsync = async (data) => {
        try {            
            const newAssignmentApi = await fetchAuthorized(ApiRoutes.User.SaveProjectTeam(),
            {                    
                method: HttpMethods.POST,
                body: JSON.stringify(data),
                collectErrorDetails: true
            }); 
    
            const editedAssignment = await newAssignmentApi.json();
            setState({ editedAssignment, isSaved: true });
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
            setState({ isSaved: false });
          }
    }

    const deleteTeamAsync = async (data) => {
        try {            
            await fetchAuthorized(ApiRoutes.User.DeleteProjectTeam({ projectTeamId: data }),
            {                    
                method: HttpMethods.DELETE
            });
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    return (
        <Provider value={{
            state,
            getRolesAsync,
            getTeamAsync,
            saveProjectTeamAsync,
            deleteTeamAsync
        }}>
            {props.children}
        </Provider>
    );
}